var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaNetworks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic networks",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M115.77 49.1724L107.563 34.5776L75.3749 52.6788V16.75H58.6249V52.6788L26.437 34.5776L18.2295 49.1724L49.9205 67L18.2295 84.8276L26.437 99.4224L58.6249 81.3213V117.25H75.3749V81.3213L107.563 99.4224L115.77 84.8276L84.0793 67L115.77 49.1724Z",
    fill: "url(#paint0_linear_9146_76311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M66.9997 27.9193C73.1669 27.9193 78.1663 22.9198 78.1663 16.7526C78.1663 10.5854 73.1669 5.58594 66.9997 5.58594C60.8325 5.58594 55.833 10.5854 55.833 16.7526C55.833 22.9198 60.8325 27.9193 66.9997 27.9193Z",
    fill: "url(#paint1_linear_9146_76311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M111.667 53.0443C117.834 53.0443 122.833 48.0448 122.833 41.8776C122.833 35.7104 117.834 30.7109 111.667 30.7109C105.499 30.7109 100.5 35.7104 100.5 41.8776C100.5 48.0448 105.499 53.0443 111.667 53.0443Z",
    fill: "url(#paint2_linear_9146_76311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.3337 53.0443C28.5008 53.0443 33.5003 48.0448 33.5003 41.8776C33.5003 35.7104 28.5008 30.7109 22.3337 30.7109C16.1665 30.7109 11.167 35.7104 11.167 41.8776C11.167 48.0448 16.1665 53.0443 22.3337 53.0443Z",
    fill: "url(#paint3_linear_9146_76311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M66.9997 128.419C73.1669 128.419 78.1663 123.42 78.1663 117.253C78.1663 111.085 73.1669 106.086 66.9997 106.086C60.8325 106.086 55.833 111.085 55.833 117.253C55.833 123.42 60.8325 128.419 66.9997 128.419Z",
    fill: "url(#paint4_linear_9146_76311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.3337 103.294C28.5008 103.294 33.5003 98.2948 33.5003 92.1276C33.5003 85.9604 28.5008 80.9609 22.3337 80.9609C16.1665 80.9609 11.167 85.9604 11.167 92.1276C11.167 98.2948 16.1665 103.294 22.3337 103.294Z",
    fill: "url(#paint5_linear_9146_76311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M111.667 103.294C117.834 103.294 122.833 98.2948 122.833 92.1276C122.833 85.9604 117.834 80.9609 111.667 80.9609C105.499 80.9609 100.5 85.9604 100.5 92.1276C100.5 98.2948 105.499 103.294 111.667 103.294Z",
    fill: "url(#paint6_linear_9146_76311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M67 83.75C76.2508 83.75 83.75 76.2508 83.75 67C83.75 57.7492 76.2508 50.25 67 50.25C57.7492 50.25 50.25 57.7492 50.25 67C50.25 76.2508 57.7492 83.75 67 83.75Z",
    fill: "url(#paint7_linear_9146_76311)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9146_76311",
    x1: 66.9999,
    y1: 16.75,
    x2: 66.9999,
    y2: 117.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9146_76311",
    x1: 43.6241,
    y1: 9.53437,
    x2: 73.6745,
    y2: 34.8544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9146_76311",
    x1: 111.667,
    y1: 30.7109,
    x2: 111.667,
    y2: 53.0443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9146_76311",
    x1: -1.0419,
    y1: 34.6594,
    x2: 29.0084,
    y2: 59.9794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9146_76311",
    x1: 43.6241,
    y1: 110.034,
    x2: 73.6745,
    y2: 135.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9146_76311",
    x1: -1.0419,
    y1: 84.9094,
    x2: 29.0084,
    y2: 110.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9146_76311",
    x1: 88.2911,
    y1: 84.9094,
    x2: 118.341,
    y2: 110.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9146_76311",
    x1: 31.9367,
    y1: 56.1727,
    x2: 77.0122,
    y2: 94.1527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaNetworks);
export default __webpack_public_path__ + "static/media/figma-networks.1c54a395400111ea6050bccb315b75ca.svg";
export { ForwardRef as ReactComponent };